import {
  Box, Grid,
  Typography
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import {
  TitleTypography
} from "./CardTabs.styles";
import type { CardTabsProps } from "./CardTabs.types";
import { CardCategories } from "../CardCategories";
import { CardSignature } from "../CardSignature";
import { CardType } from "../CardType";
import { CommonWidgetContainer } from "../Commons/CommonWidgetContainer.styles";

export function CardTabs({
  categories,
  duration,
  expirationDate,
  isTest,
  isSurvey,
  learningObjectType,
  learningObjectTypology,
  overTitle,
  shortDescription,
  title,
  ...props
}: CardTabsProps) {

  const theme = useTheme();
  const { t }= useTranslation();
  return (
    <Grid container { ...props } >
      <CommonWidgetContainer minWidth={ "100%" } sx={ {
        gap:"1rem"
      } }>
        <CardType
          isSurvey={ Boolean(isSurvey) }
          isTest={ Boolean(isTest) }
          learningObjectTypology={ learningObjectTypology }
          learningObjectType={ learningObjectType }
          color={ theme.customColors.textPrimary }
          sx={ {
            [theme.breakpoints.down("sm")]:{
              "p":{
                fontSize:"1rem",
                fontWeight: "700",
                lineHeight: "21px",
                textTransform: "uppercase"
              }
            }
          } }
        />
        <TitleTypography variant="h3">
          { title }
        </TitleTypography>
        {
          overTitle ? (
            <Box
              alignItems={ "center" }
              display={ "flex" }
              gap={ 0.5 }
            >
              { t("care_of") }
              <Typography sx={ {
                textTransform:"capitalize",
                [theme.breakpoints.down("sm")]:{
                  fontSize:"0.875rem"
                }
              } }>
                { overTitle }
              </Typography>
            </Box>

          ) : null
        }
        {
          categories && categories.length > 0 ?
            <CardCategories categories={ categories }/> : null
        }
        {
          duration || expirationDate ?
            <CardSignature
              duration={ duration }
              expirationDate={ expirationDate }
            /> : null
        }

        <Typography
          lineHeight={ 1.3125 }
          textAlign="start"
          fontSize={ "24px" }
          sx={ {
            [theme.breakpoints.down("sm")]:{
              fontSize:"0.875rem"
            }
          } }
        >
          { shortDescription }
        </Typography>
      </CommonWidgetContainer>
    </Grid>
  );
}
